import { USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022 } from "@faire/web-api--source/indigofair/settings/USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingLayoutElementComposableTile = () => {
  const setting = useSetting(
    USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022,
    false
  );
  return setting;
};
